export const MAX_API_RETRY_COUNT = 10;
export const MIN_API_DELAY = 1000;
export const MAX_API_DELAY = 10000;
